import { omit } from "lodash";
import React, { Key, ReactNode, useEffect, useState } from "react";

type ACTabContentItem = {
  content: ReactNode | ReactNode[];
  value: Key;
  preserveOnHide?: boolean;
  testId?: string;
  forceRender?: boolean;
};

export default function ACTabContent({
  items,
  value,
}: {
  items: ACTabContentItem[];
  value: Key;
}) {
  const [contentMountState, setContentMountState] = useState<
    Record<Key, boolean>
  >(() => {
    const state = { [value]: true };
    items.forEach((item) => {
      if (item.forceRender) {
        state[item.value] = true;
      }
    });
    return state;
  });

  useEffect(() => {
    setContentMountState((prev) => {
      return omit(
        { ...prev, [value]: true },
        items.filter((i) => !i.preserveOnHide).map((i) => i.value),
      );
    });
  }, [value, items]);

  return (
    <div className="ac-tab-content">
      {items.map((item) => {
        return (
          <div
            key={item.value}
            className={`ac-tab-content-item-${item.value}`}
            data-test-id={
              item?.testId ||
              `tab-content-${String(item?.value ?? "unknown")
                .toLowerCase()
                .replace(/\s+/g, "-")}`
            }
            style={{
              display:
                contentMountState[item.value] && value !== item.value
                  ? "none"
                  : undefined,
            }}
          >
            {(contentMountState[item.value] || value === item.value) &&
              item.content}
          </div>
        );
      })}
    </div>
  );
}
